<template>
  <div>
      <h2>Adding up soon!</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>